import React from 'react';
import { type SidePanelItem } from 'javascripts/shared-types';
import CommentsSidePanelTabComponent from './CommentsSidePanelTabComponent';
import CommentsSidePanelContent from './CommentsSidePanelContent';

interface CommentsSidePanelItemParams {
  annotatableType: string;
  annotatableId: string;
  className?: string;
  sidebarId: string;
  titleContent?: SidePanelItem['titleContent'];
  baseUrl?: string;
  isShared?: boolean;
}

function CommentsSidePanelItem(
  params: CommentsSidePanelItemParams
): SidePanelItem {
  const {
    annotatableType,
    annotatableId,
    className,
    sidebarId,
    titleContent,
    baseUrl,
    isShared,
  } = params;

  return {
    id: 'comments',
    name: 'Comments',
    icon: 'fa-regular fa-comment',
    alwaysRendered: true,
    titleContent,
    tabContent: (
      <CommentsSidePanelTabComponent
        annotatableType={annotatableType}
        annotatableId={annotatableId}
      />
    ),
    content: (
      <CommentsSidePanelContent
        recordType={annotatableType}
        recordId={annotatableId}
        sidebarId={sidebarId}
        className={className}
        baseUrl={baseUrl}
        isShared={isShared}
      />
    ),
  };
}

export default CommentsSidePanelItem;
